import careConfig from "@careConfig";
import { useEffect } from "react";

export interface IPageTitleProps {
  title: string;
}

export default function PageHeadTitle({ title }: IPageTitleProps) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title
      ? `${title} | ${careConfig.appName}`
      : careConfig.appName;
    return () => {
      document.title = prevTitle;
    };
  }, [title]);

  return <></>;
}
